var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("store-finder", {
    attrs: {
      lat: "51.142796",
      lng: "10.502827",
      zoom: "7",
      bbox: "5.988658,47.302488,15.016996,54.983104",
      "api-key": "/UPZjd3W6GoUfx5mrGtMCHeiKD1gcNZBAnw05tgHxDs=",
      showWelcomeParts: _vm.path == "home"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }